import { createApiClient, ApiError } from '@lunary/api-client'
import { runtimeApiBase } from '../config'
import { reloadDeck } from '@lunary/ui-web/deck'
import { reportOutage } from '@lunary/ui-web/outage'

let accessToken: string | null = null

export function setAccessToken(token: string | null): void {
  accessToken = token
  reloadDeck()
}

export function getAccessToken(): string | null {
  return accessToken
}

export const api = createApiClient({
  baseUrl: runtimeApiBase(),
  getAccessToken: () => accessToken,
  refreshAccessToken: async () => {
    const res = await api.post<{ access_token: string }>('/auth/refresh')
    accessToken = res.access_token
    return accessToken
  },
  onAuthFailure: () => {
    if (!accessToken) return
    accessToken = null
    window.location.reload()
  },
  onUnavailable: () => reportOutage(`${runtimeApiBase()}/health`),
  headers: { 'x-client': 'admin' },
})

export { ApiError }
